import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import {
  Info,
  Price,
  PriceBreakdownTableWrapper,
  PriceLabel,
} from './PriceBreakdownTable.styles';
import { formatCurrency } from '@/modules/utils/currency';

export interface PriceBreakdownTableProps {
  prices: {
    label: string;
    info?: string;
    price: number | undefined | null;
    bold?: boolean;
    ignore?: boolean;
  }[];
  stackedDesktop?: boolean;
  alignDesktop?: alignVals;
}

export type alignVals = 'start' | 'end' | 'space-between';

function PriceBreakdownTable({
  prices,
  stackedDesktop,
  alignDesktop = 'space-between',
}: PriceBreakdownTableProps) {
  const availablePrices = prices.filter((price) => price.price);
  const alignVal = availablePrices.length > 5 ? 'space-between' : alignDesktop;


  return (
    <PriceBreakdownTableWrapper
      stackedDesktop={stackedDesktop}
      alignDesktop={alignVal}
    >
      {prices.map((priceData, index) => {
        const { price, bold, label, info } = priceData;
        if (!price) return;
        return (
          <Price stackedDesktop={stackedDesktop} key={index}>
            <PriceLabel>
              <Text appearance={TokenTextAppearance.copy200} bold={bold}>
                {label}
              </Text>
              {info && <Info appearance={TokenTextAppearance.copy200}>{info}</Info>}
            </PriceLabel>
            <Text appearance={TokenTextAppearance.copy200} bold={bold}>
              {formatCurrency(price)}
            </Text>
          </Price>
        );
      })}
    </PriceBreakdownTableWrapper>
  );
}

export default PriceBreakdownTable;
